import { Injectable } from '@angular/core';
import { VaultRowModel } from '@app/vault/models/vault-row.model';

/**
 * This service is used to parse vault records associated with BigCommerce Surface authentication.
 * 
 * For context: This vault record is initialized during Gadget Surface App onboarding flow via the FDX API.
 * These vault records are then updated during FDX Auth Flow to contain authentication and configuration info.
 */
@Injectable({
    providedIn: 'root'
})
export class VaultParsingBigCommerceService {
    getChannelIdFromVaultRecord(exportVaultRecord: VaultRowModel[]): string | null {
        const channelCreds = exportVaultRecord[0]?.parseCredentials<Record<string, unknown>>();

        // Important: Older stores will not have the channel object in the vault record.
        const channel = channelCreds?.['channel'] as { id?: string | number; } | undefined;
        if (channel?.id === null || channel?.id === undefined) {
            return null;
        }

        return `${channel.id}`;
    }

    getStorefrontIdFromVaultRecord(surfaceVaultRecord: VaultRowModel): number | null {
        const surfaceCreds = surfaceVaultRecord?.parseCredentials<Record<string, unknown>>();

        const storefront = surfaceCreds?.['storefront'] as { id?: number; } | undefined;
        if (storefront?.id === null || storefront?.id === undefined) {
            return null;
        }

        return storefront.id;
    }
}
